import * as React from 'react';
import type {
  FetchTollPreviewDataPayload as Payload,
  TollPreviewDataResponseData as Response,
} from 'contracts/transport-routes';
import { apiGeneral } from 'services/api';

export const useFetchTollPreview = () => {
  const fetchTollPreview = React.useCallback(async (payload: Payload) => {
    const { data } = await apiGeneral.post<Response>(`/general-route/toll-preview-data`, payload);
    return data
  }, []);

  return {
    fetchTollPreview
  }
};